import { Mark } from '@chakra-ui/react';
import React from 'react';

interface Props {
  query: string;
  children: React.ReactNode;
}

export const HighlightSearchTerm: React.FC<Props> = ({ query, children }) => {
  const queryWords = Array.from(
    new Set(query.toLowerCase().split(/\s+/).filter(Boolean)),
  );

  const highlightText = (text: string) => {
    if (!queryWords.length) return text;

    return text.split(/(\s+)/).map((word, index) => {
      const matchingQuery = queryWords.find((q) => word.toLowerCase() === q);

      if (matchingQuery) {
        return (
          <Mark
            key={index}
            backgroundColor="secondary.50"
            fontWeight="500"
            color="currentColor"
          >
            {word}
          </Mark>
        );
      }

      return word;
    });
  };

  const processChildren = (child: React.ReactNode): React.ReactNode => {
    if (typeof child === 'string') {
      return highlightText(child);
    }

    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...child.props,
        children: processChildren(child.props.children),
      });
    }

    if (Array.isArray(child)) {
      return child.map((nestedChild, index) => (
        <React.Fragment key={index}>
          {processChildren(nestedChild)}
        </React.Fragment>
      ));
    }

    return child;
  };

  return <>{processChildren(children)}</>;
};
